import React from 'react'
import Liberyus from '../../components/general/liberyus'
import AboutBanner from './about-banner'
import AboutContent from './about-content'
// import AboutVideo from './about-video'
import HomeOurTeam from '../home/home-our-team'

const AboutPage = () => {
    return (
        <Liberyus>
            <div className='about-page'>
                <AboutBanner />
                <AboutContent />
                {/* <AboutVideo /> */}
                <HomeOurTeam />
            </div>
        </Liberyus>
    )
}

export default AboutPage
